// File: frontend/src/views/private/admin/TMS.js

import React from 'react';
import AdminPageTemplate from '../../../components/layout/AdminPageTemplate';
import { FileCode } from 'lucide-react';

const TMS = () => {
  return (
    <AdminPageTemplate
      title="Template Management System"
      subtitle="Create and manage document templates and workflows"
      icon={FileCode}
      showComingSoon={true}
    />
  );
};

export default TMS;